import { BallBg, Col } from 'components';
import { Api } from 'lib';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import {
    AthAndFanZone,
    AthleteFocus, Banner, Calculator, News,
    PartnersAndTeams, Shoutout
} from './components';

import { Loading } from '../components';

const HomePage = (props) => {
  const [data, setData] = useState(null),
    [loading, setLoading] = useState(true),
    { isMobile, directedToLogin } = useSelector((state) => state.appState),
    navigate = useNavigate(),
    { state } = useLocation(),
    dispatch = useDispatch();

  useEffect(() => {
    fetchInitial();
  }, []);

  async function fetchInitial() {
    const res = await Api.post('/website/fetchInitial');
    if (!res) return;

    setData(res);
    setLoading(false);

    if (state?.fromAuth || directedToLogin) return;

    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        directedToLogin: true
      }
    });

    if (!isMobile) {
      /*
        Initial isMobile handler
      */
      dispatch({
        type: 'UPDATE_APP_STATE',
        payload: {
          isMobile: window.innerWidth < 1024
        }
      });
    }
    navigate('/signup');
  }

  return (
    <React.Fragment>
      <Loading isLoading={loading} />
      <BallBg />

      {data && (
        <React.Fragment>
          <Banner />

          <Col marg="0 0 112px" noFlex start>
            <Shoutout />
            <AthAndFanZone />
            <PartnersAndTeams data={data} />
            <Calculator />
            <AthleteFocus />
            <News data={data.news} />
          </Col>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default HomePage;
